import { Ajax } from '@newrelic/browser-agent/features/ajax';
import { GenericEvents } from '@newrelic/browser-agent/features/generic_events';
import { JSErrors } from '@newrelic/browser-agent/features/jserrors';
import { Metrics } from '@newrelic/browser-agent/features/metrics';
import { PageViewEvent } from '@newrelic/browser-agent/features/page_view_event';
import { PageViewTiming } from '@newrelic/browser-agent/features/page_view_timing';
import { SessionTrace } from '@newrelic/browser-agent/features/session_trace';
import { Spa } from '@newrelic/browser-agent/features/spa';
import { Agent } from '@newrelic/browser-agent/loaders/agent';
import { IS_CI, IS_LOCAL_DEV, IS_LOCAL_OR_CI_CYPRESS } from '@utils/constants';
import { RESOLVED_TENANT_HOSTNAME } from '../../config';
import { IS_PR_PREVIEW } from '../../utils/constants';

const baseInfo = {
  beacon: 'bam.nr-data.net',
  errorBeacon: 'bam.nr-data.net',
  licenseKey: 'NRBR-80fec329ab4cb14f96e',
  // applicationID: '1120369134',
  sa: 1,
};
const baseLoaderConfig = {
  accountID: '2452316',
  trustKey: '2452316',
  agentID: '1120369134',
  licenseKey: 'NRBR-80fec329ab4cb14f96e',
  // applicationID: '1120369134',
};

const connectCarrierConfig = {
  'connect-carrier.dev.hub.mastermindtms.com': {
    applicationID: '1120369134',
  },
  'connect-carrier.test.hub.mastermindtms.com': {
    applicationID: '1120369158',
  },
  'connect-carrier.uat-e.hub.mastermindtms.com': {
    applicationID: '1120369159',
  },
  'connect-carrier.uat-c.hub.mastermindtms.com': {
    applicationID: '1120369160',
  },
  'connect-carrier.hub.mastermindtms.com': {
    applicationID: '1120369161',
  },
} as const;

const matched = (connectCarrierConfig as anyOk)[RESOLVED_TENANT_HOSTNAME];

const options = {
  info: { ...baseInfo, applicationID: matched?.applicationID },
  loader_config: { ...baseLoaderConfig, applicationID: matched?.applicationID },
  init: {
    distributed_tracing: { enabled: true },
    privacy: { cookies_enabled: true },
    ajax: { deny_list: ['bam.nr-data.net'] },
  },
};

if (IS_LOCAL_DEV || IS_CI || IS_LOCAL_OR_CI_CYPRESS || IS_PR_PREVIEW) {
  // noop
} else if (matched) {
  new Agent({
    ...options,
    features: [
      Ajax,
      GenericEvents,
      JSErrors,
      Metrics,
      PageViewEvent,
      PageViewTiming,
      SessionTrace,
      Spa,
    ],
  });
} else {
  // eslint-disable-next-line no-console
  console.error(
    'New Relic not initialized due to missing config. Domain:',
    RESOLVED_TENANT_HOSTNAME,
  );
}
